import * as Yup from 'yup';
import { PqrFinalCausality } from '../../../../../../shared/types/modules/pqr';

export const initialValues: PqrFinalCausality = {
    causality: '',
    motive: '',
    protection: '',
};

export const validationSchema = Yup.object({});
